import React from 'react';
import { AppStatusBadge } from '@shared/components/ui/status-badge/AppStatusBadge';
import { SectionCard } from '../../components/sections/SectionCard';
import { CUSTOMER_DETAILS } from '@shared/data';
import { PANEL_TEXT_STYLES } from '../../constants/text-styles';
import type { PaymentDetail } from '../../types/panel-common.types';

interface CustomerDetailsProps {
  customerData?: PaymentDetail[];
  className?: string;
  /** Section title. Defaults to "Details" to match the other detail sections. */
  title?: string;
}

export const CustomerDetails = React.memo<CustomerDetailsProps>(({
  customerData,
  className,
  title = 'Details',
}) => {
  const details = customerData ?? CUSTOMER_DETAILS;

  return (
    <SectionCard title={title} layout="down" className={className}>
      <div className="flex flex-col gap-4">
        {details.map((detail) => (
          <div key={detail.label} className="flex flex-col gap-1">
            <p className={PANEL_TEXT_STYLES.label}>{detail.label}</p>
            <div className={PANEL_TEXT_STYLES.value}>
              {detail.showBadge ? (
                <AppStatusBadge
                  variant="generic"
                  text={detail.value}
                  color={
                    detail.badgeVariant === 'destructive' ? 'error' :
                    detail.badgeVariant === 'secondary' ? 'neutral' :
                    detail.badgeVariant === 'success' ? 'success' :
                    'info'
                  }
                />
              ) : (
                <span>{detail.value}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
});

CustomerDetails.displayName = 'CustomerDetails';
